import React, { useEffect } from "react";
import { times } from "../../../utils/date";
import { Layer } from "grommet";
import {
  StyledLinkWrapper,
  StyledButton,
  StyledParagraph,
  StyledTitle,
  StyledTitleWrap,
  StyledTopBorder,
  StyledTopRow,
  StyledWrapper,
  StyledMainContent,
  StyledMainTitle,
} from "./styles";
import { AccordionPanel } from "../../Accordions/AccordionPanel";
import BuyEventInfo from "../../BuyEventInfo";
export var BuyEventPopup = function BuyEventPopup(_ref) {
  var statePopupHandler = _ref.statePopupHandler,
    setEvent = _ref.setEvent,
    currentEvent = _ref.currentEvent,
    promocode = _ref.promocode,
    isCertificate = _ref.isCertificate,
    formats = _ref.formats,
    loadFormats = _ref.loadFormats,
    cleanFormats = _ref.cleanFormats,
    loadTickets = _ref.loadTickets,
    allTickets = _ref.allTickets,
    getPromocode = _ref.getPromocode,
    addShop = _ref.addShop,
    as = _ref.as;
  useEffect(
    function () {
      if (currentEvent) {
        loadFormats(currentEvent.event_public_id, currentEvent.cityId);
        /*  loadTeams(currentEvent.event_public_id); */
      }
    },
    [currentEvent]
  );

  var closePopup = function closePopup() {
    statePopupHandler(false);
    setEvent({});
    cleanFormats([]);
  };

  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    formats.length
      ? /*#__PURE__*/ React.createElement(
          Layer,
          {
            onClickOutside: closePopup,
            onEsc: closePopup,
            animation: "fadeIn",
          },
          /*#__PURE__*/ React.createElement(
            StyledWrapper,
            null,
            /*#__PURE__*/ React.createElement(
              StyledTopRow,
              null,
              /*#__PURE__*/ React.createElement(
                StyledTopBorder,
                null,
                /*#__PURE__*/ React.createElement("img", {
                  src: currentEvent.event_type.logo,
                  width: "70",
                  alt: currentEvent.event_type.title,
                }),
                /*#__PURE__*/ React.createElement(
                  StyledTitleWrap,
                  null,
                  /*#__PURE__*/ React.createElement(StyledTitle, null, currentEvent.event.title),
                  currentEvent.event.external_url === null
                    ? /*#__PURE__*/ React.createElement(
                        StyledLinkWrapper,
                        {
                          as: as,
                          to: "event/" + formats[0].event_public_id,
                        },
                        "\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435"
                      )
                    : /*#__PURE__*/ React.createElement(
                        StyledLinkWrapper,
                        {
                          href: currentEvent.event.external_url,
                        },
                        "\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435"
                      )
                ),
                /*#__PURE__*/ React.createElement(
                  StyledParagraph,
                  null,
                  currentEvent && times.getDayOfWeek(currentEvent.start_time)
                )
              )
            ),
            /*#__PURE__*/ React.createElement(
              StyledMainContent,
              null,
              /*#__PURE__*/ React.createElement(
                StyledMainTitle,
                null,
                "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0444\u043E\u0440\u043C\u0430\u0442"
              ),
              formats.length
                ? formats.map(function (format, index) {
                    return /*#__PURE__*/ React.createElement(
                      AccordionPanel,
                      {
                        key: format.public_id,
                        format: format,
                        initialState: formats.length === 1 ? [index] : [],
                      },
                      /*#__PURE__*/ React.createElement(BuyEventInfo, {
                        format: format,
                        logo: currentEvent.event_type.logo,
                        id: format.public_id,
                        promocode: promocode,
                        getPromocode: getPromocode,
                        isCertificate: isCertificate,
                        addShop: addShop,
                        loadTickets: loadTickets,
                        allTickets: allTickets,
                      })
                    );
                  })
                : null
            ),
            /*#__PURE__*/ React.createElement(StyledButton, {
              onClick: closePopup,
              type: "button",
              "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
            })
          )
        )
      : null
  );
};
